import config from "../config";
import { setSectionNumber } from './section-indicators';
import sceneBuilderSprites from "./scene-builder-sprites";
import { setSpriteOnCanvas } from '../common';

const deviceCanvas = document.getElementById(
  "device-canvas"
) as HTMLCanvasElement;
const deviceContext = deviceCanvas.getContext("2d");

const deviceScreenVideo = document.getElementById(
  "device-screen-video"
) as HTMLVideoElement;

export default function(){
  const sceneId = 'scene-1-7';
  const targetScene = config[sceneId];

  const tlCanvasRotateGrow = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-rotate-grow`,
      trigger: `#${targetScene.id}-canvas-start`,
      start: `top-=${config.scrollSpan} center+=${config.pinTextOffset}`,
      end: `+=${config.scrollSpan * 2}`,
      pin: false, // pinSpacing is handled in CSS
      // markers: true,
      onEnter: () => setSectionNumber(1),
      // onEnterBack: () => {
      //   try {
      //     console.log("tlCanvasRotateGrow onEnterBack PLAY VIDEO scene17");
      //     deviceScreenVideo.play();
      //   } catch(e){
      //     console.error('error playing scene 1-7 video');
      //   }
      // },
      onLeaveBack: () => {
        gsap.set(
          "#device-screen-video-wrapper",
          {
            display: "none",
            onComplete: function () {
              console.log("HIDE VIDEO, tlCanvasRotateGrow.onLeaveBack");
              try {
                deviceScreenVideo.pause();
              } catch (e) {
                console.error("error pausing scene 1-7 video");
              }
            },
          },
        );
      },
      scrub: true, // override the scrub: 1 default to solve the "delayed trigger" issue on our video https://greensock.com/forums/topic/24490-scrolltrigger-issue-with-anchor-link-or-fast-scroll-past/
    },
  });
  tlCanvasRotateGrow.addLabel("start");
  tlCanvasRotateGrow.to(
    "#scroll-prompt",
    {
      duration: 0.25,
      yPercent: -20,
      autoAlpha: 0,
      display: 'none',
    },
    "start"
  );

  tlCanvasRotateGrow.to(
    "#device-canvas-container",
    {
      duration: 1.5,
      // height: "90vw",
      // width: "90vw",
      left: "75%",
      // yPercent: -5,
      height: "90vh",
      width: "90vh",
      yPercent: 0,
      scale: 1.75,
      ease: Sine.easeInOut,
    },
    "start"
  );
  tlCanvasRotateGrow.addLabel("land");

  tlCanvasRotateGrow.call(function(){
    try {
      console.log("PLAY VIDEO scene17");
      deviceScreenVideo.play();
    } catch(e){
      console.error('error playing scene 1-7 video');
    }
  }, [], 'land');
  tlCanvasRotateGrow.to(
    "#device-screen-video-wrapper",
    {
      duration: 0.05,
      autoAlpha: 1,
      display: "block",
      onStart: function(){
        console.log("SHOW VIDEO, tlCanvasRotateGrow");
      }
    },
    "land"
  );

  const tlCanvasRotateBack = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-canvas-rotate-back`,
      trigger: `#${targetScene.id}-spec-list-2`,
      start: `top-=${config.scrollSpan} center+=${config.pinTextOffset}`,
      end: `+=${config.scrollSpan}`,
      // markers: true,
      pin: false,
      scrub: true, // override the scrub: 1 default to solve the "delayed trigger" issue on our video https://greensock.com/forums/topic/24490-scrolltrigger-issue-with-anchor-link-or-fast-scroll-past/
      onEnter: function () {
        console.log("HIDE VIDEO, tlCanvasRotateBack.onEnter");
        gsap.set("#device-screen-video-wrapper", {
          display: "none",
        });
        try {
          deviceScreenVideo.pause();
        } catch (e) {
          console.error("error pausing scene 1-7 video");
        }
      },
    },
  });
  tlCanvasRotateBack.addLabel("start");
  tlCanvasRotateBack.set(
    "#device-screen-video-wrapper",
    {
      display: 'none',
      onComplete: function(){
        console.log("HIDE VIDEO, tlCanvasRotateBack.set");
        try {
          deviceScreenVideo.pause();
        } catch(e){
          console.error('error pausing scene 1-7 video');
        }
      }
    },
    "start"
  );
  tlCanvasRotateBack.to(
    "#device-canvas-container",
    {
      duration: 1,
      height: "90vh",
      width: "90vh",
      left: "75%",
      scale: 1,
      yPercent: 0,
    },
    "start"
  );

  // sceneBuilder(sceneId);
  sceneBuilderSprites(targetScene);

  const tlEnd = gsap.timeline({
    scrollTrigger: {
      id: `${targetScene.id}-canvas-end`,
      trigger: `#${targetScene.id}-canvas-end`,
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          `+=${config.scrollSpanMobile}`;
        }
        return `+=${config.scrollSpan}`;
      },
      // markers: true,
      onEnterBack: () => setSectionNumber(1),
      onUpdate: (self) => {
        const offset =
          targetScene.keyframeSpan * (targetScene.keyframeCount - 1);
        let frameNumber = Math.floor(
          self.progress * targetScene.keyframeSpan + offset
        );
        setSpriteOnCanvas({
          context: deviceContext,
          targetFrameIndex: frameNumber,
          spriteSettings: targetScene.sprites,
        });
      },
    },
  });

  if (!config.mobileLayout){
    const tlEndMoveDeviceCanvas = gsap.timeline({
      scrollTrigger: {
        id: `${targetScene.id}-canvas-end-move`,
        trigger: `#${targetScene.id}-canvas-end`,
        start: `top center+=${config.pinTextOffset}`,
        end: `+=${config.scrollSpan * 2 + 100}`, // 3 for scrollSpan at bottom of spec-list-5 plus scrollSpan*2 of scene-2 explode
        // markers: true,
      },
    });
    tlEndMoveDeviceCanvas.addLabel("start");
    tlEndMoveDeviceCanvas.to(
      "#device-canvas-container",
      {
        duration: 1,
        left: "35%",
        ease: Sine.easeInOut,
      },
      "start"
    );
  }
}